import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { GlobalContext } from '../../Context/GlobalContext';
import useAxios from '../../Hooks/useAxios';
import { DATE_FORMAT, STATUS_RESOLVED } from '../../Constants/Global';
import AltaCentroForm, {getPositionSpecific, getEmployeeId} from '../AltaCentroForm/AltaCentroForm';
import MenuListTasks from '../MenuListTasks/MenuListTasks';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, Typography } from '@mui/material';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
//import { MANAGER_DEPARTMENT, STATUS_RESOLVED } from '../../Constants/Global';
import { AxiosService } from '../../Services/AxiosService';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from 'react-oidc-context';
import { useNavigate, useLocation } from 'react-router-dom';
import ProcessDetails from "../../Components/ProcessDetails/ProcessDetails";
import { getEndProcessDate } from "../../Components/ProcessDetails/ProcessDetails";
const { fixEndDate, getWorkingDaysDifference, modifyEndDate } = require("../../Utils/date.util.js");


/**
 * A reusable Paper component for the draggable dialog. This component is used to wrap the dialog content
 * and enable dragging functionality.
 * 
 * @component
 * @param {Object} props - The component props.
 * @param {React.RefObject} props.nodeRef - A ref to the Paper component.
 * @returns {JSX.Element} A draggable Paper component.
 */
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper 
        {...props} 
        ref={nodeRef} 
        className="formPaper" 
        sx={{
          overflow: "auto",
          position: "fixed",
          top: "90px",
          maxWidth: "460px",
          // minWidth: "360px",
          borderRadius: "30px"
        }}/>
    </Draggable>
  );
}




/**
 * A popup dialog component for displaying and managing subprocess details. It includes a form for viewing
 * subprocess information and a button for resolving the subprocess if the user has the necessary permissions.
 * 
 * @component
 * @returns {JSX.Element} The rendered subprocess popup dialog component.
 */
function AltaCentroPopup() {
  const {
    modalOpen,
    modalAltaCentroOpen,
    setModalAltaCentroOpen,
    modalData,
    setAlertOpen,
    setAlertType,
    setAlertTitle,
    setAlertMessage,
    userProperties,
    setAlertBarSeverity,
    setAlertBarMessage,
    setAlertBarOpen,
    setRefreshTable
  } = React.useContext(GlobalContext);

   const { data, isLoading, error } = useAxios("subprocessDetail", modalData.id);

   const [endDate, setEndDate]= React.useState();
   const [loadingRequest, setLoadingRequest] = React.useState(false);

   const navigate = useNavigate();
   const auth = useAuth();
   const { pathname } = useLocation();


   let processEndDate = getEndProcessDate();
   let AltaCentroEndDate = data?.endDate;
   let NewAltaCentroEndDate = endDate;
   //console.log("processEndDate: ", processEndDate);
   //console.log("AltaCentroEndDate: ", data?.endDate);
   //console.log("NewAltaCentroEndDate: ", endDate);
   //console.log("DataSubProcessZ: ", data);
    let difference = getWorkingDaysDifference(AltaCentroEndDate, NewAltaCentroEndDate);
    console.log("difference: ", difference);
    console.log("processEndDate: ", processEndDate);

    let NewProcessEndDate = modifyEndDate(processEndDate, difference);


    // console.log("NewProcessEndDate: ", NewProcessEndDate);

   /**
     * Handles changes to the end date in the process form.
     *
     * @param {Object} event - The date picker change event.
     */
     const handleDateChange = (event) => {
      setEndDate(event.format(DATE_FORMAT));
     };

   /**
     * Refreshes the current view based on the application's pathname.
     * - For "/calendar" route: Forces a navigation refresh by temporarily redirecting to "/#"
     * - For "/processes" route: Increments the refresh counter to trigger a table re-render
     * - For all other routes: No action is taken
     *
     * @function refreshView
     * @returns {void}
     *
     * @example
     * // When on calendar view:
     * refreshView(); // Will force refresh the calendar
     *
     * @example
     * // When on processes view:
     * refreshView(); // Will increment refresh counter causing table to reload
     */
    const refreshView = () => {
      switch (pathname) {
        case "/calendar":
          navigate("/#");
          break;

        case "/processes":
          setRefreshTable(prev => prev + 1);
          break;

        default:
          break;
      }
    }



  /**
   * Determines whether the "Resolve" button should be displayed based on the user's permissions and the subprocess status.
   */
  const showResolveButton = !isLoading && !error && data.statusId !== STATUS_RESOLVED && 
    (data.departmentId === userProperties.departmentId || data.responsibleId === userProperties.id); // || userProperties.departmentId === MANAGER_DEPARTMENT)

  /**
   * Handles closing the dialog when the user clicks outside, presses the Escape key,
   * or interacts with specific elements.
   * 
   * @param {Event} event - The event triggering the close action.
   */
   const handleClose = () => {
        setModalAltaCentroOpen(false);
      };

  // const handleClose = (event) => {
  //   if (event.nativeEvent.code === "Escape"
  //     || (event.target.tagName !== "H2"
  //       && event.target.tagName !== "LI"
  //       && event.target.tagName !== "DIV")){
  //     setModalAltaCentroOpen(false);
  //   }
  // };

  /**
   * Handles the "Resolve" button click. Displays a confirmation dialog for resolving the subprocess.
   */
  const handleAccept = () => {
    setAlertType("resolve_subtask");
    setAlertTitle(<Typography color='success'><DoneOutlineIcon color="success" sx={{ fontWeight:'fontWeightBold', position: "relative", top: "5px", marginRight: "10px" }} />Resolve task</Typography>);
    setAlertMessage(<Typography>Are you sure you want to solve the task?<br/>This action cannot be undone</Typography>);
    // setModalOpen(false);
    setAlertOpen(true);
  };


  /**
     * Handles the "Save" button click. Saves the updated end date for the process via an API call.
     */
    const handleSave = () => {

        console.log("--------------getPosition: ", getPositionSpecific());
        console.log("--------------getEmployeeId: ", getEmployeeId());


        setLoadingRequest(true);
        const requestBody =  {
          endDate: NewProcessEndDate
        };
        console.log(modalData)
        console.log("modalData : ", modalData)
        console.log("requestBody : ", requestBody)
        console.log("NewProcessEndDate : ", NewProcessEndDate)



        const requestBody0 =  {

            targetEmployee: {

                positionSpecific: getPositionSpecific()
                }

            }
             console.log("requestBody: ", requestBody0);

        AxiosService.patch_position_specific(auth.user?.access_token, requestBody0, getEmployeeId())
        .then((response) => {
          //console.log("response: ", response);
          //setLoadingPOST(false);
          setAlertBarSeverity("success");
          setAlertBarMessage(response.data.message);
          setAlertBarOpen(true);
          //setNewTaskOpen(false);
          //navigate("/#");
        })


        console.log("requestBody++++: ", requestBody);
        AxiosService.update_task(auth.user?.access_token, modalData.type === "process"? modalData.id : modalData.label, requestBody)
        .then((response) => {
          setAlertBarSeverity("success");
          setAlertBarMessage(response.data.message);
          setAlertBarOpen(true);
          //setProcessModalOpen(false);
          setModalAltaCentroOpen(false);
          refreshView();
        })
        .catch((err) => {
          setAlertBarSeverity("error");
          setAlertBarMessage(`${err.message} (${err.response.statusText}): ${err.response.data.error}`);
          setAlertBarOpen(true);
        })
        .finally(() => {
          setLoadingRequest(false);
        });
    }



  
  // Generate the dialog title based on the subprocess data or loading/error state
  let popupTitle = "";

  if (!isLoading){
    if (error) {
      setAlertBarSeverity("error");
      setAlertBarMessage(error);
      setAlertBarOpen(true);
      popupTitle = error;
    } else {
      popupTitle = <MenuListTasks item={{...data, type: "subprocess"}} tagType="forms" key={"subprocess" + data.id} />;
    }
  } else {
    popupTitle = <><CircularProgress size="1rem" sx={{marginRight: "4px"}} />Loading...</>;
  }

  return (
    <> 
    <Dialog
      open={setModalAltaCentroOpen}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'unset' }} id="draggable-dialog-title" onClick={handleClose}>
        {popupTitle}
      </DialogTitle>
      {!isLoading && !error &&
      <DialogContent sx={{maxHeight: "62vh"}}>
          <AltaCentroForm subProcessData={data} handleDateChange={handleDateChange}></AltaCentroForm>
      </DialogContent>}
      {!isLoading &&
      <DialogActions> 
        <Button sx={{  fontWeight:'fontWeightBold' }} onClick={handleClose}>
          <CloseIcon/> Exit
        </Button>
        {showResolveButton && <Button color="success" sx={{ fontWeight:'fontWeightBold' }} onClick={handleAccept}>
          <DoneIcon /> Resolve
        </Button>}

        <Button color="primary" sx={{ fontWeight:'fontWeightBold', margin: "auto" }} onClick={handleSave} loading={loadingRequest}>
          <SaveIcon /> Save
        </Button>
        <ProcessDetails/>

      </DialogActions>

      }
    </Dialog>
  </>
  );
}

export default AltaCentroPopup;
